import { Component, Inject, Renderer2, DOCUMENT } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppService } from './services/app.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { AppEnum } from './appenum';
import { ThemingService } from './services/theming.service';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from './app.settings';
import { EncryptionService } from './services/encryption.service';
import { environment } from 'src/environments/environment';
import { LoggingService } from './services/logging.service';
import { AppNavigationService } from './services/app-navigation.service';
import { CustomTranslateService } from './services/custom-translate.service';


declare const gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent {
  public isLogoLoded = false;
  public deviceInfo: any;
  public param: any;
  public ScheduleTime: any;
  public username: any;
  public showTime: any;
  public UserName: any;
  isTaskDetailsLoaded = false;
  public currentDateTime: any;
  url: any;
  lang: any;
  language: any = [];
  isHeaderVisible: boolean = true;
  defaultLanguageSelect: any;
  componentName: any = 'app-component';
  BUCKET_URL: string;
  passUrl: string;
  hashkey: any;
  datetime: string;
  constructor(public _nav: NavController,
    public _appenum: AppEnum,
    private deviceService: DeviceDetectorService,
    private platform: Platform,
    private _activatedRoute: ActivatedRoute,
    public _themeService: ThemingService,
    public router: Router,
    private titleService: Title,
    public _translateService: TranslateService,
    public _appsetting: AppSettings,
    public _appServices: AppService,
    public loggingService: LoggingService,
    private renderer: Renderer2,
    private _appNav: AppNavigationService,
    private customTranslate: CustomTranslateService,
    @Inject(DOCUMENT) private document: Document,
    public encryptionService: EncryptionService) {
    var ths = this;
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState == 'hidden') {
        ths._appServices.logsActivity(ths._appenum.EntityOfLogLevel.Critical, 'Visibility Change Browser Tab close or open New Tab', 'App Component');
      }
    });
    // this.initializeApp();
  }
  ngOnInit() {
    if (window.self !== window.top) {
      window.top.location.href = window.self.location.href;
    }
    if (environment.production) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }
    this.loadGoogleMaps();
    this.customTranslate.initLangSubscription();
    this.pagerevisit()
    this.googleTracking();
    this._appServices.showHeader.subscribe(res => {
      this.isHeaderVisible = res;
    })
  }

  loadGoogleMaps(): void {
    if ((window as any).google?.maps) { // Prevent duplicate loading
      return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&v=weekly`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  async pagerevisit() {
    let url = AppService.getAppUrl();
    const urlObj = new URL(url);
    const urlTaskId = urlObj.searchParams.get('taskId');
    const rawParam = urlObj.search.replace('?', '').replace(/=+$/, '');;
    const isRealHashKey = rawParam.length >= 5 && rawParam.length <= 8 && !rawParam.includes('=');
    const urlHashKey = isRealHashKey ? rawParam : null;
    const currentHashKey = urlHashKey
      ? urlHashKey
      : this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this._appenum.EntityOfLocalStorageKeys.hashKey
        )
      );
    const taskId = this._appServices.getTaskIdFromCookieByHashKey('authToken', currentHashKey);
    if (taskId) {
      sessionStorage.setItem('tabId', taskId);
      this.gotoDashBoard();
    } else {
      await this.detectDevice();
    }
  }

  async gotoDashBoard() {
    this.defaultLanguageSelect = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    var langData = (this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.languageData)))
    this.language = langData ? JSON.parse(langData) : langData;
    this.lang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    this._appsetting.selectedLanguage = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    await this._translateService.setDefaultLang(this.lang);
    this._translateService.use(this.lang);
    this.isTaskDetailsLoaded = true;
    this.isLogoLoded = true;
    this._themeService.myMethod(JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.themeDetail))).themeconfig);
    this._appNav.navigateRoot(['/user-panel/dashboard']);
  }

  // New Code
  async detectDevice() {
    if (this.platform.is('desktop')) {
      if (environment.qualys) {
        await this.handleMobileFlow();
      } else {
        this.isTaskDetailsLoaded = true;
        this._appNav.navigateRoot(['page-not-found', { errorcode: 'desktop' }]);
      }
    } else if (this.platform.is('mobileweb') || this.platform.is('pwa')) {
      await this.handleMobileFlow();
    }
  }

  private async handleMobileFlow(): Promise<void> {
    try {
      let currentUrl = AppService.getAppUrl();
      const urlParts = currentUrl.split('?');
      this.passUrl = urlParts[0];
      const baseUrl = urlParts[0];
      const queryString = urlParts.length > 1 ? urlParts[1].replace(/=+$/, '') : null;
      let cleanedUrl: string;
      let hashKey: string | null = null;
      cleanedUrl = baseUrl.includes('.assisted.')
        ? baseUrl.replace('.assisted.', '.')
        : baseUrl;
      // Validate if query is real inspection hash
      if (queryString && this.isInspectionHash(queryString)) {
        // localStorage.clear();
        hashKey = queryString;
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true
        });
        await this.verifyUrl(hashKey, cleanedUrl);

      } else {
        // Refresh OR internal navigation case
        const storedHash = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.hashKey))
        cleanedUrl = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.Selfurl))
        this.passUrl = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.Originurl))
        if (storedHash) {
          await this.verifyUrl(storedHash, cleanedUrl);
        }
      }

    } catch (error) {
      console.error('handleMobileFlow error:', error);
    }
  }

  private isInspectionHash(value: string): boolean {
    if (value.length < 5 || value.length > 10) return false;
    const hashRegex = /^[a-zA-Z0-9]+$/;
    return hashRegex.test(value);
  }

  async googleTracking() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e) => {

      const rt = this.getChild(this._activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(`Digital Eyes Assisted PWA | ${data.title}`);
        this.googleAnalytics(e);
      });
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  googleAnalytics(event) {
    var agentid = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentid));
    var Token = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken));
    if (agentid) {
      var pageTitle = this.titleService.getTitle();
      gtag('js', new Date());
      gtag('get', 'UA-206497206-1', 'client_id', (clientID) => {
      });
      gtag('set', 'client_id', agentid);
      gtag('set', { 'dimension1': agentid });
      gtag('set', { 'dimension2': agentid });
      gtag('config', 'UA-206497206-1', { cookie_flags: 'max-age=7200;secure;samesite=Strict;' });
      gtag('event', 'page_view', {
        event: event,
        page_title: pageTitle,
        page_path: event.urlAfterRedirects
      });
    }
  }

  async verifyUrl(hashkey, originalUrl) {
    this.hashkey = hashkey;
    // var originUrl = this.url.split('?')[0]
    this.datetime = new Date().toISOString();
    const postJson = {
      hashKey: this.hashkey,
      currentTime: this.datetime,
      url: originalUrl.replace(/\/$/, '')
    };
    setTimeout(() => {
      this.isPrivateWindowOrNot(postJson)
    }, 1000)
  }


  async isPrivateWindowOrNot(postJson) {
    let hello = new Uint8Array([72, 101, 108, 108, 111]); // "Hello" in binary form
    let blob = new Blob([hello, ' ', 'world'], { type: 'text/plain' });
    const fileUrl = new File([blob], 'self_' + new Date().getTime().toString(), { type: "text/plain" });
    var isNotPrivate = await this._appServices.insertdummyblob(fileUrl);
    if (isNotPrivate != 'private window') {
      this.callApi(postJson);
    } else {
      this.navigatetoPrivatepage(postJson)
    }
  }

  callApi(postJson) {
    const logRequest: any = {
      apiEndUrl: environment.endpoint.verifyInspectionURL,
      reqBody: postJson,
    };
    this._appServices.postDataWithPromiseWithoutAuth(environment.endpoint.verifyInspectionURL, postJson).then(async (res) => {
      this.loggingService.handleResponseLog(
        res.StatusCode == 200
          ? 'info'
          : res.StatusCode == 409
            ? 'warning'
            : 'error',
        logRequest,
        res.StatusCode,
        res.Message,
        'verifyInspectionURL Api Call',
        this.componentName,
        environment.endpoint.verifyInspectionURL
      );
      this._appServices.isDataLoading.next(false);
      localStorage.removeItem(this.encryptionService.encrypt(this._appenum.EntityOfLocalStorageKeys.authtoken));
      if (res.StatusCode == '200') {
        sessionStorage.setItem('tabId', res.Data[0].taskId);
        this.encryptionService.localstorageEncrypt(
          this._appenum.EntityOfLocalStorageKeys.Selfurl,
          postJson.url
        );
        this.encryptionService.localstorageEncrypt(
          this._appenum.EntityOfLocalStorageKeys.Originurl,
          this.passUrl
        );
        this.encryptionService.localstorageEncrypt(
          this._appenum.EntityOfLocalStorageKeys.hashKey,
          postJson.hashKey
        );
        this._themeService.myMethod(res.Data[0].themeDetails.themeconfig);
        this.username = res.Data[0].FirstName.split(' ');
        this.UserName = res.Data[0].FirstName;
        var first_name = this.username[0];
        this.defaultLanguageSelect = res.Data[0].themeDetails.language_data.filter(item => item.default)[0].code
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale, this.defaultLanguageSelect);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected, this.defaultLanguageSelect);
        this.lang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale));
        this._appsetting.selectedLanguage = this.defaultLanguageSelect;
        this.language = res.Data[0].themeDetails.language_data;
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.OrgId, res.Data[0].orgId);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.languageData, JSON.stringify(res.Data[0].themeDetails.language_data));
        await this._translateService.setDefaultLang(this.lang)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.username, first_name);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.maskmobile, res.Data[0].userMobile);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.userunmaskmobile, res.Data[0].userUnmaskedMobile);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.userid, res.Data[0].userId);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.agentid, res.Data[0].agentId);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.taskid, res.Data[0].taskId);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.userEmail, res.Data[0].userEmail);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.usename, res.Data[0].FirstName);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.taskStatus, res.Data[0].taskStatus);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.InspectionStatus, res.Data[0].status);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.urlExpiryTime, res.Data[0].urlExpiryTime);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.userMobile, res.Data[0].userMobile);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.agentname, res.Data[0].agentName);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.agentphone, res.Data[0].agentMobile);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.flag, 'valid');
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.statusManagementFlag, res.Data[0].statusManagementFlag);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.themeDetail, JSON.stringify(res.Data[0].themeDetails));
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.assetsBucket, res.Data[0].themeDetails["assets-bucket"])
        this.ScheduleTime = res.Data[0].scheduleTime;
        this._appServices.isLangDataLoading.next(true);
        this.setFontsBucket();
        setTimeout(() => {
          const passData = {
            userid: res.Data[0].userId,
            maskmobileno: res.Data[0].userMobile,
            maskEmail: res.Data[0].userEmail,
            usename: res.Data[0].FirstName,
            userType: 'user',
            flag: 'valid',
            imageUrl: res.Data[0].templateImageURL == '' ? '../assets/images/home.png' : res.Data[0].templateImageURL
          }
          var urlData = this.encryptionService.encrypt(JSON.stringify(passData))
          this._appNav.navigate(['verify-otp'], { queryParams: { q: urlData } });
          this._appServices.loaderDismiss();
          this.isLogoLoded = true;
          this.isTaskDetailsLoaded = true;
        }, 2000)
        // this._appServices.isDataLoading = false;
      } else if (res.StatusCode == '403') {
        await this._translateService.setDefaultLang(this.lang)
        this._translateService.use(this.lang)
        // this._appServices.loaderDismiss();
        let defLang = res.Data[0]?.themeDetails?.language_data.filter(item => item.default)[0].code
        this._appNav.navigateRoot(['page-not-found', { errorcode: res.StatusCode, errormsg: res.Message['en'] }]);
        this.isTaskDetailsLoaded = true;
      } else if (res.StatusCode == '400' && res.Data.length > 0) {
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.OrgId, res.Data[0].themeDetails.orgid);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.languageData, JSON.stringify(res.Data[0].themeDetails.language_data));
        this.language = res.Data[0].themeDetails.language_data;
        this.defaultLanguageSelect = res.Data[0].themeDetails.language_data.filter(item => item.default)[0].code
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected, this.defaultLanguageSelect);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale, this.defaultLanguageSelect);
        this.lang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
        await this._translateService.setDefaultLang(this.lang)
        this._translateService.use(this.lang);
        this._themeService.myMethod(res.Data[0].themeDetails.themeconfig);
        setTimeout(() => {
          this.compareTime(res.Data[0]);
        }, 500)
        this.isTaskDetailsLoaded = true;
      } else if (res.StatusCode == '400' && res.Data.length == 0) {
        // this._appServices.loaderDismiss();
        this._appNav.navigateRoot(['page-not-found', { errorcode: res.StatusCode, errormsg: res.Message['en'] }]);
        this.isTaskDetailsLoaded = true;
      } else if (res.StatusCode == '401' && res.Data[0].status == 'complete') {
        // this._appServices.loaderDismiss();
        this._appNav.navigateRoot(['page-not-found', { errorcode: '400', errormsg: res.Message['en'] }]);
        this.isTaskDetailsLoaded = true;
      }
    }, (err) => {
      this.loggingService.logApiError(
        'error',
        logRequest,
        err,
        'verifyInspectionURL Api Call',
        this.componentName,
        environment.endpoint.verifyInspectionURL
      )
      this._appServices.loaderDismiss();
      this.isTaskDetailsLoaded = true;
    });
  }

  async navigatetoPrivatepage(data) {
    this.isTaskDetailsLoaded = true;
    const passData = {
      hashkey: data.hashKey,
      url: this.passUrl
    }
    var urlData = this.encryptionService.encrypt(JSON.stringify(passData))
    this._appNav.navigateRoot(['private-window'], { queryParams: { q: urlData } });
  }
  setFontsBucket() {
    let assetsBucket = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.assetsBucket));
    this.BUCKET_URL = 'https://storage.googleapis.com/' + assetsBucket;
    const style = this.renderer.createElement('style');
    style.textContent = `
      @font-face {
        font-family: 'inter-400';
        src: url('/assets/fonts/Inter_24pt-Regular.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Regular.ttf');
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: 'inter-500';
        src: url('/assets/fonts/Inter_24pt-Medium.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Medium.ttf');
        font-weight: 500;
        font-style: normal;
      }
      @font-face {
        font-family: 'inter-600';
        src: url('/assets/fonts/Inter_24pt-Medium.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Medium.ttf');
        font-weight: 600;
        font-style: normal;
      }
      @font-face {
        font-family: 'inter-700';
        src: url('/assets/fonts/Inter_24pt-Bold.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Bold.ttf');
        font-weight: 700;
        font-style: normal;
      }
    `;
    this.renderer.appendChild(this.document.head, style);
  }

  compareTime(ResultData) {
    this.isLogoLoded = true;
    var showtime = this.convertUTCDateToLocalDate(new Date(ResultData.scheduleTime));
    var bufferTime = ResultData.bufferTimeFrame > 60 ? ResultData.bufferTimeFrame / 60 + ' ' + 'hours' : ResultData.bufferTimeFrame + ' ' + 'minutes'
    // this._nav.navigateRoot(['verify-otp', {
    //   userid: ResultData.userId,
    //   maskmobileno: ResultData.userMobile,
    //   usename: ResultData.userName,
    //   userType: 'user',
    //   flag: 'prelogin',
    //   scheduletime: showtime.toLocaleString(),
    //   AgentName: ResultData.agentName,
    //   agentPhone: ResultData.agentMobile,
    //   buffertime: bufferTime
    // }]);
    const passData = {
      userid: ResultData.userId,
      maskmobileno: ResultData.userMobile,
      usename: ResultData.userName,
      userType: 'user',
      flag: 'prelogin',
      scheduletime: showtime.toLocaleString(),
      AgentName: ResultData.agentName,
      agentPhone: ResultData.agentMobile,
      buffertime: bufferTime
    }
    var urlData = this.encryptionService.encrypt(JSON.stringify(passData))
    this._appNav.navigate(['verify-otp'], { queryParams: { q: urlData } });
  }
  convertUTCDateToLocalDate(date) {
    var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000)
    return newDate;
  }
}
